<template>
<div>
  <search-list
    :projectList = "projectList"
    :leaseTimeeEnums = "leaseTimeeEnums"
    :surrenderStatuseEnums = "surrenderStatuseEnums"
    :surTypeEnums = "surTypeEnums"
    :surrenderBalanceEnums="surrenderBalanceEnums"
    :surModeEnums="surModeEnums"
    :surrenderAuditTypeEnum="surrenderAuditTypeEnum"
    @findData="findData">
  </search-list>
  <div class="page-wrapper">
    <table-list
      :columns="columns"
      :defaultColumns ="defaultColumns"
      :data="tableData"
      :total="total"
      :current="current"
      :loading="loading"
      @change-page="changePage"
    >
      <Button type="primary" class="btn" @click="exportSurrenderList" :loading = "btnLoading" v-p="{menu:'termination',api:'surrender/downloadSurrenderList'}">导出解约协议</Button>
    </table-list>
  </div>
  <release-person :n="releasePersonKey"
                  :contractFid="contractFid"
                  :stockFid="stockFid"
                  @done="findData(searchData)"
                  :surMode="surMode"
                  :surStatus="surStatus"
  ></release-person>
  <colse-termination :n="closeKey" :surrenderFid="closeSurrenderFid" @refresh="findData(searchData)"></colse-termination>

</div>
</template>

<script type="text/ecmascript-6">
import { getConditions,surrenderList,downloadSurrenderList,checkSurrenderCount } from 'api/termination'
import {getProjects } from 'api/common'
import SearchList from './components/SearchList'
import ColseTermination from './components/ColseTermination'
// import TableList from 'components/TableList/index';
import TableList from "components/FilterTableList/index";
import ReleasePerson from './../contractList/components/ReleasePerson2'


export default {
  name:'termination',
  components:{
    SearchList,
    ColseTermination,
    TableList,
    ReleasePerson
  },
  created(){
     this.initData()
  },
  watch: {
    $route(to, from) {
     if(from.name=='releasebusiness' && from.query.fromreleases==1){
      this.findData(this.searchData)
     }
    }
  },
  data () {
    return {
      surStatus:null,
      surMode:null,
      surModeEnums:[],
      surrenderAuditTypeEnum:[],
      surrenderBalanceEnums:[],
      btnLoading:false,
      loading:true, // true
      total:0,
      current:1,
      closeKey:0,
      contractFid:'',
      stockFid:'',
      releasePersonKey:1,
      closeSurrenderFid:'',
      searchData:{
        projectFid:'',
        surType:'',
        surStatus:'',
        leaseTime:'',
        surReleaseStartDate:'',
        surReleaseEndDate:'',
        surApplicationStartDate:'',
        surApplicationEndDate:'',
        contractCode:null,
        surCode:null,
        customerName:null,
        userPhone:null,
        stockFid:null,
        handleZo:null,
        limit: 10,
        page: 1,
        surAuditType:''
      },
      leaseTimeeEnums:[], // 出租类型
      surrenderStatuseEnums:[], // 解约协议状态
      surTypeEnums:[], // 解约类型
      projectList:[],
      columns:[
        {
        type:'index',
        width:60,
        align:'center'
        },

        {
          title:'项目',
          key:'projectName',
          align:'center',
          width:160
        },

        {
          title:'房间/床位号',
          key:'stockNumber',
          align:'center',
          width:120
        },

         {
          title:'解约协议编号',
          key:'surCode',
          align:'center',
          width:180,
          render:(h,params) => {
            return h('a',{
              on:{
                click: ()=>{
                  if (params.row.subjectType === 1){
                    this.$router.push({
                      name: 'personalterminationdetail',
                      query:{
                        surrenderFid: params.row.surFid,
                        // parentSurrenderFid: params.row.parentSurrenderFid,
                        contractFid:params.row.contractFid
                      }
                    })
                  }else if (params.row.subjectType === 3){
                    this.$router.push({
                    name: 'companyterminationdetail',
                    query:{
                      surrenderFid: params.row.surFid,
                      parentSurrenderFid: params.row.parentSurrenderFid,
                      contractFid:params.row.contractFid
                    }
                  })
                  }
                }
              }
            },params.row.surCode)
          }
        },

        {
          title:'解约方式',
          key:'surModeName',
          align:'center',
          width:120,
        },

        {
          title:'审核类型',
          key:'surAuditTypeName',
          align:'center',
          width:120,
        },

        {
          title:'父解约协议编号',
          key:'parentSurCode',
          align:'center',
          width:180,
        },

        {
          title:'解约类型',
          key:'surTypeName',
          align:'center',
          width:100
        },

        {
          title:'解约客户',
          key:'customerName',
          align:'center',
          width:220
        },

        {
          title:'解约日期',
          key:'surReleaseDate',
          align:'center',
          width:120
        },

        {
          title:'结算金额',
          key:'costAmount',
          align:'center',
          width:120,
          render:(h,params) =>{
            let costAmount = Number(params.row.costAmount).toFixed(2);
            return h('div',{
              style:{
                'text-align':'right'
              }
            },Number(costAmount).toLocaleString())
          }
        },

        {
          title:'结算状态',
          key:'balanceStatusName',
          align:'center',
          width:100
        },

        {
          title:'解约协议状态',
          key:'surStatusName',
          align:'center',
          width:120
        },

        {
          title:'审核人',
          key:'surAuditZo',
          align:'center',
          width:80
        },

        {
          title:'审核日期',
          key:'surAuditDate',
          align:'center',
          width:120
        },

        {
          title:'解约ZO',
          key:'handleZo',
          align:'center',
          width:120
        },


        {
          title:'客户手机号',
          key:'surCustomerPhone',
          align:'center',
          width:120
        },

        {
          title:'解约申请日期',
          key:'surApplicationdate',
          align:'center',
          width:120
        },

        {
          title: '操作',
          key: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            // 未提交：0 ，带审核：1，审核驳回：2，审核通过：3，已关闭：4
            // 修改 状态为【未提交】、【待审核】、【审核驳回】【待客户确认解约】时展示并可操作
            // 关闭：状态为【未提交】时展示并可操作
            return h('div', [h('a', {
              directives:[
                {
                  name:'p',
                  value:{
                    menu:'termination',
                    api:'surrender/getSurrenderGoodsDeliveryInitInfo'
                  }
                }
              ],
              style: {
                marginRight: '5px',
                display: params.row.surStatus === 0 || params.row.surStatus === 2 || params.row.surStatus === 5 ? 'inline-block' : 'none'
              },
              on: {
                click: () => {
                  // 判断客户类型， 个人弹窗  企业跳企业解约
                  this.contractFid = params.row.contractFid;
                  this.stockFid = params.row.stockFid;
                  this.surMode=params.row.surMode
                  this.surStatus=params.row.surStatus
                  if (params.row.subjectType === 3) {
                    this.$router.push({
                      name: 'releasebusiness',
                      params: {id: params.row.contractFid},
                      query: {fromreleases: 1}
                    })
                  } else {
                    this.releasePersonKey++
                  }
                }
              }
            }, '修改'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      menu:'termination',
                      api:'surrender/closeSurrenderProtocol'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.surStatus === 0 || params.row.surStatus === 5 ? 'inline-block' : 'none'
                },
                on: {
                  click: () => {
                    this.closeSurrenderFid = params.row.surFid;
                    this.closeKey++
                  }
                }
              }, '关闭')
            ])
          }
        }
      ],
      defaultColumns:['surModeName','parentSurCode','surAuditTypeName','balanceStatusName','projectName','stockNumber', 'surCode','surTypeName', 'customerName', 'surReleaseDate', 'costAmount', 'surStatusName', 'surAuditZo', 'surAuditDate','handleZo','action' ],
      tableData:[]
    };
 },
 methods:{
   changePage(n){
      this.loading  = true;
      this.current = n;
      this.searchData.page = n;
      this.getList(this.searchData)
    },
    exportSurrenderList(){
      let data = {};
      for (let key in this.searchData) {
        if(key==='page' || key==='limit') continue;
        data[key] = this.searchData[key]
      }
      checkSurrenderCount(data).then( res => {
        if(res.data > 10000){
          this.$Modal.info({
            title: '导出解约协议',
            content:'上限10000条，请选择条件后下载'
          });
        } else {
            this.btnLoading = true;
            downloadSurrenderList(data).then( res => {
            let fileName = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);

                  let url = window.URL.createObjectURL(blob);
                  let link = document.createElement('a');
                  link.style.display = 'none';
                  link.href = url;
                  link.setAttribute('download', fileName);
                  document.body.appendChild(link);
                  link.click();
                  this.btnLoading = false

          }).catch( err => {
            this.btnLoading = false;
            console.log('err')
          })
        }
      })
    },
    initData(){
      getProjects().then( res => {
        this.projectList = res.data;
        if(this.projectList && this.projectList.length > 0){
          this.searchData.projectFid = this.projectList[0].value
        }
        this.getList(this.searchData)
      });
      getConditions().then( res => {
        this.leaseTimeeEnums = res.data.leaseTimeeEnums;
        this.surrenderStatuseEnums = res.data.surrenderStatuseEnums;
        this.surTypeEnums = res.data.surTypeEnums;
        this.surrenderBalanceEnums=res.data.surrenderBalanceEnums

        this.surModeEnums=res.data.surModeEnums
        this.surrenderAuditTypeEnum = res.data.surrenderAuditTypeEnum

      });
    },
    getList(data){
      this.loading = true;
      surrenderList(data).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.loading = false
      })
    },
   findData(data){

     this.current = 1;
     this.searchData = data;
     this.searchData.page = 1;
     this.getList(this.searchData)
   }
 }
}
</script>
